import { Injectable } from '@angular/core'

import { PkwDatastore } from '../../../pkw-data/pkw-datastore'
import { ExtratoDeVendas } from '../../../pkw-data/collect/extrato/extrato-de-vendas.model'
import { Pagina, ListaPaginada } from '../../../pkw-data/core/util/lista-paginada.model'

@Injectable()
export class ExtratoDeVendasService {
    constructor(private pkwDatastore: PkwDatastore) {}

    obter(id: string) {
        return this.pkwDatastore.findRecord(ExtratoDeVendas, id)
    }

    pesquisar(filtro: any, indicePagina?: number, tamanhoPagina?: number) {
        const pagina = new Pagina(indicePagina, tamanhoPagina)

        return this.pesquisarPaginado(filtro, pagina)
    }

    pesquisarPaginado(filtro: any, pagina: Pagina) {
        const params = {
            filter: filtro,
            page: pagina.toLimitOffset()
        }

        return this.pkwDatastore
            .findAll(ExtratoDeVendas, params)
            .map(
                reponse =>
                    new ListaPaginada<ExtratoDeVendas>(
                        reponse.getModels(),
                        pagina.indice,
                        pagina.tamanho,
                        reponse.getMeta().meta.totalResourceCount
                    )
            )
    }
}



// WEBPACK FOOTER //
// ./src/app/extratos/extratos-de-vendas/shared/extrato-de-vendas.service.ts